import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableModule } from 'primeng/components/datatable/datatable';
import { SharedModule } from 'primeng/components/common/shared';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/components/calendar/calendar';
import { ConfirmDialogModule } from 'primeng/components/confirmdialog/confirmdialog';
import { ConfirmationService } from 'primeng/components/common/api';
import { GrowlModule } from 'primeng/primeng';
import { DistributorsRoutingModule } from './distributors-routing.module';
import { DistributorsService } from './services/distributors.service';
import { DistributorsComponent } from './distributors.component';
import { DistributorDetailComponent } from './distributor-detail/distributor-detail.component';
import { DistributorContractDetailComponent } from './distributor-contract-detail/distributor-contract-detail.component';
import { DistributorContractAreaDetailComponent } from './distributor-contract-area-detail/distributor-contract-area-detail.component';
import { DistributorContractsService } from './services/distributor-contracts.service';
import { DistributorContractAreasService } from './services/distributor-contract-areas.service';
import { DistributorProductDetailComponent } from './distributor-product-detail/distributor-product-detail.component';
import { DistributorProductsService } from './services/distributor-products.service';
import { PostcodesModule } from '../postcodes/postcodes.module';
import { DialogModule } from 'primeng/components/dialog/dialog';
import { TabViewModule } from 'primeng/primeng';
import { FieldsetModule } from 'primeng/primeng';
import { PickListModule } from 'primeng/primeng';

@NgModule({
	imports: [
		CommonModule,
		DistributorsRoutingModule,
		DataTableModule,
		SharedModule,
		FormsModule,
		CalendarModule,
		ConfirmDialogModule,
		DialogModule,
		GrowlModule,
		PostcodesModule,
		TabViewModule,
		FieldsetModule,
		PickListModule
	],
	exports: [
		DistributorsComponent,
		DistributorsRoutingModule,
	],
	providers: [
		DistributorsService,
		DistributorContractsService,
		DistributorContractAreasService,
		ConfirmationService,
		DistributorProductsService
	],
	declarations: [
		DistributorsComponent,
		DistributorDetailComponent,
		DistributorContractDetailComponent,
		DistributorContractAreaDetailComponent,
		DistributorProductDetailComponent
	]
})
export class DistributorsModule
{
}



// WEBPACK FOOTER //
// ./src/app/distributors/distributors.module.ts